<script>
    import axios from 'axios'

    export default {
		props: {
			step: { type: Number },
		},
		data: function () {
			return {
				open: false,
				storageKey: 'question-popover'
			};
		},
		methods: {
			fetchValue: function () {
				if (Grabcad.questionsTooltip.length > 0) return Grabcad.questionsTooltip;
				return this.localStorageValue() || '---';
			},
			storeValue: function (value) {
				if (!value || !value.length) return;
				Grabcad.questionsTooltip = value;
				return axios.put('/community/api/v1/members/preference/questions_tooltips_tracking', {
					value: value
				});
			},
			getTracked: function (index) {
				return this.fetchValue()[index];
			},
			setTracked: function (index) {
				let value = this.fetchValue();
				return value.substring(0, index) + '1' + value.substring(index + 1);
			},
			close: function () {
				this.open = false;
				let newValue = this.setTracked(this.step);
				this.storeValue(newValue);
			},
			localStorageValue: function () {
				return window.localStorage.getItem(this.storageKey);
			},
			requestSuccess: function () {
				if (!localStorage) return;
				localStorage.removeItem(this.storageKey);
			},
			onCreated: function () {
				if ((!Grabcad.questionsTooltip.length || Grabcad.questionsTooltip === '---') &&
					(this.localStorageValue() !== Grabcad.questionsTooltip)) {
					this.storeValue(this.localStorageValue());
				}

				if (this.getTracked(this.step) != '1') {
					this.open = true;
				}
			}
		},
		created: function () {
			if (!localStorage || !Grabcad.authenticated) return;
			if (window.innerWidth < 768) return;
			return this.onCreated();
		}
	}

</script>